<template>
    <LayoutDefault>
        Callback
    </LayoutDefault>
</template>

<script>
    import { mapActions } from 'vuex'
    import LayoutDefault from '@/components/layouts/LayoutDefault'

    export default {
        components: {
            LayoutDefault,
        },

        computed: {},

        data() {
            return {
                Ds_MerchantParameters: null,
                id: 9,
                matriculaFinish: {},
            }
        },

        methods: {
            ...mapActions('Login', ['loginUser']),
            ...mapActions('Matricula', ['tpvBackPostData']),
        },

        async mounted() {
            this.$nextTick(async() => {
                if (this.$route.query.Ds_MerchantParameters) {
                    let merchant_base64 = this.$CryptoJS.enc.Base64.parse(this.$route.query.Ds_MerchantParameters)
                    this.Ds_MerchantParameters = JSON.parse(this.$CryptoJS.enc.Utf8.stringify(merchant_base64))

                    let logToken = await this.loginUser({
                        username: process.env.VUE_APP_API_USER,
                        password: process.env.VUE_APP_API_PASSWORD,
                        componentId: this.id
                    })

                    if (logToken) {
                        let code = parseInt(this.Ds_MerchantParameters.Ds_Response)
                        this.matriculaFinish = await this.tpvBackPostData({
                            numeroPedido: this.Ds_MerchantParameters.Ds_Order,
                            code: code,
                            componentId: this.id
                        })
                    }
                }
            })
        },
    }
</script>